import { Injectable } from '@angular/core';
import { BonusHistory, BonusHistoryList, OccBonusHistorySearchParams } from '@my-account/const';
import { MyAccountActions, MyAccountSelectors, StateWithMyAccount } from '@my-account/data-access';
import { Store } from '@ngrx/store';
import { CustomPaginationModel } from '@shared/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BonusHistoryService {
  constructor(private store: Store<StateWithMyAccount>) {}

  loadBonusHistory(params?: OccBonusHistorySearchParams): void {
    this.store.dispatch(new MyAccountActions.LoadBonusHistory(params));
  }

  getBonusHistory(): Observable<BonusHistory> {
    return this.store.select(MyAccountSelectors.getBonusHistoryValue);
  }

  getBonusHistoryBonuses(): Observable<BonusHistoryList[]> {
    return this.getBonusHistory().pipe(map((items) => (items ? items.bonuses : undefined)));
  }

  getBonusHistoryPagination(): Observable<CustomPaginationModel> {
    return this.getBonusHistory().pipe(map((items) => (items ? items.pagination : undefined)));
  }
}
